import {
  PartnerProfileFormValues,
  PartnerProfileFormViolation,
} from 'types/partnerProfileFormTypes';
import { stringIsEmpty } from 'utils/stringUtils';
import {
  PARTNER_PROFILE_AVATAR_INPUT_FILE_TYPES,
  PARTNER_PROFILE_AVATAR_INPUT_FILE_MAX_SIZE,
} from './constants';

export const validatePartnerProfileFormValues = (
  values: PartnerProfileFormValues,
  editing: boolean
): PartnerProfileFormViolation[] => {
  const violations: PartnerProfileFormViolation[] = validatePartnerProfileFormValuesImmediately(
    values
  );

  if (!values.avatar && !editing) {
    violations.push({
      name: 'AvatarMissed',
    });
  }

  if (stringIsEmpty(values.firstName)) {
    violations.push({
      name: 'FirstNameMissed',
    });
  }

  if (stringIsEmpty(values.lastName)) {
    violations.push({
      name: 'LastNameMissed',
    });
  }

  if (stringIsEmpty(values.middleName)) {
    violations.push({
      name: 'MiddleNameMissed',
    });
  }

  if (stringIsEmpty(values.phone)) {
    violations.push({
      name: 'PhoneMissed',
    });
  }

  if (values.country === null) {
    violations.push({
      name: 'CountryMissed',
    });
  }

  if (stringIsEmpty(values.city)) {
    violations.push({
      name: 'CityMissed',
    });
  }

  if (stringIsEmpty(values.details)) {
    violations.push({
      name: 'DetailsMissed',
    });
  }

  return violations;
};

export const validatePartnerProfileFormValuesImmediately = (
  values: PartnerProfileFormValues
): PartnerProfileFormViolation[] => {
  const violations: PartnerProfileFormViolation[] = [];

  if (values.avatar) {
    if (
      !PARTNER_PROFILE_AVATAR_INPUT_FILE_TYPES.includes(
        values.avatar.rawFile.type
      )
    ) {
      violations.push({
        name: 'AvatarInputFileType',
      });
    }

    if (
      values.avatar.rawFile.size > PARTNER_PROFILE_AVATAR_INPUT_FILE_MAX_SIZE
    ) {
      violations.push({
        name: 'AvatarInputFileSize',
      });
    }
  }

  return violations;
};

export const createPartnerProfileFormViolationLense = (
  violation: PartnerProfileFormViolation
) => ({
  isFirstNameViolation() {
    switch (violation.name) {
      case 'FirstNameMissed':
        return true;
      default:
        return false;
    }
  },
  isLastNameViolation() {
    switch (violation.name) {
      case 'LastNameMissed':
        return true;
      default:
        return false;
    }
  },
  isMiddleNameViolation() {
    switch (violation.name) {
      case 'MiddleNameMissed':
        return true;
      default:
        return false;
    }
  },
  isPhoneViolation() {
    switch (violation.name) {
      case 'PhoneMissed':
        return true;
      default:
        return false;
    }
  },
  isCountryViolation() {
    switch (violation.name) {
      case 'CountryMissed':
        return true;
      default:
        return false;
    }
  },
  isCityViolation() {
    switch (violation.name) {
      case 'CityMissed':
        return true;
      default:
        return false;
    }
  },
  isAvatarViolation() {
    switch (violation.name) {
      case 'AvatarMissed':
      case 'AvatarInputFileSize':
      case 'AvatarCroppedFileSize':
      case 'AvatarInputFileType':
      case 'AvatarInputImageSize':
        return true;
      default:
        return false;
    }
  },
  isDetailsViolation() {
    switch (violation.name) {
      case 'DetailsMissed':
        return true;
      default:
        return false;
    }
  },
});
